import { FC } from 'react';
import { Tag, TagStyleVariants, Typography } from '../../../ui';
import { Divider } from '../../../atoms/divider/divider';

type Props = {
  color: TagStyleVariants['variant'];
  status: string;
  date: string;
};

export const ChangedStatusDivider: FC<Props> = (props) => {
  const { color, status, date } = props;

  return (
    <Divider>
      <div className="flex items-center space-x-8">
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale400 text-nowrap"
        >
          Status veranderd naar
        </Typography>
        <Tag variant={color} label={status} />
        <Typography
          variant="body-xxs"
          weight="regular"
          className="text-grayscale300 text-nowrap"
        >
          {date}
        </Typography>
      </div>
    </Divider>
  );
};
